import { Trans, t } from '@lingui/macro';
import {
  Grid,
  MenuItem,
  Select,
  Typography,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { DesktopDatePicker } from '@mui/lab';
import { DateTime } from 'luxon';

const AttendanceRetail = () => {
  return (
    <Paper>
      <div className='bg-primary-main text-white rounded-t px-3 py-2'>
        <Typography variant='h4'>
          <Trans>CHI TIẾT BẢNG CÔNG</Trans>
        </Typography>
      </div>
      <div className='p-3'>
        <Grid container columnSpacing={4} rowSpacing={3}>
          <Grid item sm={9}>
            <div className='mt-4'>
              <DesktopDatePicker
                value={DateTime.now()}
                onChange={() => {}}
                renderInput={(props) => <TextField {...props} />}
                label={t`Month`}
                inputFormat='MM/yyyy'
              />
            </div>
          </Grid>
          <Grid item sm={3}>
            <Typography variant='subtitle1'>
              <Trans>Doanh nghiệp hiện tại</Trans>
            </Typography>
            <Select className='my-4' size='small' fullWidth displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
              <MenuItem>
                <Trans>Company A</Trans>
              </MenuItem>
              <MenuItem>
                <Trans>Company B</Trans>
              </MenuItem>
            </Select>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className='bg-primary-dark text-white'>Company A</TableCell>
                    <TableCell className='text-center'>Full-time</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className='bg-primary-dark text-white'>Company A</TableCell>
                    <TableCell className='text-center'>Full-time</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default AttendanceRetail;
